//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery'
import { mapState } from 'vuex'

export default {
  components: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    $('body').toggleClass('fixed');
    setTimeout(() => {
      $.AdminLTE.layout.fixSidebar();
      $.AdminLTE.pushMenu.expandOnHover();
      $.AdminLTE.layout.activate();
      $.AdminLTE.controlSidebar._fix($('.control-sidebar-bg'));
      $.AdminLTE.controlSidebar._fix($('.control-sidebar'));
    }, 1000);
    $('body').on('shown.bs.modal', '.modal', function () {
      if ($('body').width() <= 780 && $('body').hasClass('sidebar-open')) {
        $('.sidebar-toggle').trigger('click');
      }
    });
  },
  computed: {
    layout: function () {
      return this.$route.meta.layout === 'main'
    },
    ...mapState({
      navigation: state => state.navigation,
      user: state => state.User.user
    })
  },
  methods: {
    navClick () {
      $('.js-nav-li').removeClass('active');
      $(event.currentTarget).addClass('active');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout.vue